// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-modal-modal_card-U3nwV {
  width: 360px;
  min-height: 200px;
  height: auto;
}

.confirm-modal-toolbar_container-jR5Zv {
  border-bottom: none;
}

.confirm-modal-toolbar_title-SHiSu {
  font-size: 17px;
  color: var(--color-neutral-900);
}

.confirm-modal-content-BYPmY {
  padding-top: 8px;
}

.confirm-modal-label-z7YtS {
  display: flex;
  align-items: center;
  font-size: 15px;
  margin-left: 4px;
  margin-top: 24px;
}

.confirm-modal-checkbox-pG0ue {
  margin: 0px;
  margin-right: 8px;
}

.confirm-modal-error_container-uQcLV {
  margin: 24px 20px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/confirm-modal/confirm-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".modal_card {\n  width: 360px;\n  min-height: 200px;\n  height: auto;\n}\n\n.toolbar_container {\n  border-bottom: none;\n}\n\n.toolbar_title {\n  font-size: 17px;\n  color: var(--color-neutral-900);\n}\n\n.content {\n  padding-top: 8px;\n}\n\n.label {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  margin-left: 4px;\n  margin-top: 24px;\n}\n\n.checkbox {\n  margin: 0px;\n  margin-right: 8px;\n}\n\n.error_container {\n  margin: 24px 20px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `confirm-modal-modal_card-U3nwV`,
	"toolbar_container": `confirm-modal-toolbar_container-jR5Zv`,
	"toolbar_title": `confirm-modal-toolbar_title-SHiSu`,
	"content": `confirm-modal-content-BYPmY`,
	"label": `confirm-modal-label-z7YtS`,
	"checkbox": `confirm-modal-checkbox-pG0ue`,
	"error_container": `confirm-modal-error_container-uQcLV`
};
export default ___CSS_LOADER_EXPORT___;
